import React from "react";
import { Menu } from "semantic-ui-react";
import { HOME_PAGE_ROUTE } from "../../app/api/routeConstants";
import { NAVBAR_STYLES } from "../../css/styles";
import { Link } from "react-router-dom";
import logo from "../../assets/icons/logo-white.svg";
import AccountMenu from "./AccountMenu";
import HamburgerMenu from "react-hamburger-menu";
import { setHrMode } from "../jobs/jobsActions";
import { HR_ALL_MODE } from "../modes/constants";
import { useDispatch } from "react-redux";

export default function NavbarMobile({ isShowSideBar, setShowSidebar }) {
  const dispatch = useDispatch();

  return (
    <Menu
      className="navbar-menu"
      text
      fixed="top"
      style={{ ...NAVBAR_STYLES.navbarHome, zIndex: 1000 }}
    >
      <Menu.Item>
        <div className="navbar-mobile-menu-icon">
          <HamburgerMenu
            isOpen={isShowSideBar}
            menuClicked={setShowSidebar}
            width={25}
            height={25}
            strokeWidth={2}
            rotate={0}
            color="white"
            borderRadius={0}
            animationDuration={0.3}
          />
        </div>
      </Menu.Item>
      <Menu.Item
        as={Link}
        to={HOME_PAGE_ROUTE}
        onClick={() => dispatch(setHrMode(HR_ALL_MODE))}
      >
        <div className="hello-radius-logo-container">
          <img
            className="hello-radius-logo"
            src={logo}
            alt="hello radius logo"
            data-testid="hello-radius-logo-image-testid"
          />
        </div>
      </Menu.Item>
      <AccountMenu navbar={NAVBAR_STYLES.navbarHome} position="right" />
    </Menu>
  );
}
